// import _ from 'lodash';
// import React, { Fragment } from 'react';
// import { inject, observer } from 'mobx-react';
// import autobind from 'autobind-decorator';
// import { NavLink } from 'react-router-dom';

// import HFMDragDropContext from 'common/components/hfm-drag-drop-context';
// import Editor from 'client/shared/components/editor';
// import documentStore from '../../../shared/stores/document-store';
// import DocumentModal from './document-modal';
// import Navigation from './navigation';
// import FAQList from './faq-list';

// @inject('documentStore')
// @observer
// class ManageDocuments extends React.Component {
// 	componentDidMount () {
// /* TODO: COde herez?? */
// 	}

// 	render () {
// 		// if (playlistStore.isLoading || songsStore.isLoading) {

// 		// 	return (<div className="loading-spinner large"></div>);
// 		// }
// 		// const { active } = this.state;
// 		// const LinkItem = ({ activeSlug, label, to }) => {
// 		// 	return (
// 		// 		<NavLink
// 		// 			className={ `primary-link ${active === activeSlug ? 'active' : ''}` }
// 		// 			onClick={ () => { this.setState({active: activeSlug}) } }
// 		// 			exact to={ to }
// 		// 		>
// 		// 			{ label }
// 		// 		</NavLink>
// 		// 	)
// 		// };
// 		const { documentStore } = this.props;

// 		const renderComp = (Comp) => (
// 			() => ( <Comp documentStore={ documentStore } type={ active } /> )
// 		);

// 		return (
// 			<Fragment>
// 				<div className="grid-x header-grid margin-bottom-1">
// 					<div className="cell small-12">
// 						<Navigation />
// 						{/* <Header member={ member } /> */}
// 					</div>
// 				</div>

// 				<div className="grid-x grid-padding-x" style={{width: '82vw'}}>
// 					<div className="cell small-12">
// 						<Route exact
// 							path="/manage-documents"
// 							render={
// 								() => ( <Redirect to="/manage-documents" /> )
// 							}
// 						/>
// 						<Route
// 							path="/manage-documents/ARTIST_FAQ"
// 							render={ renderComp(FAQList) }
// 						/>
// 						<Route
// 							path="/manage-documents/FAN_FAQ"
// 							render={ renderComp(FAQList) }
// 						/>
// 						<Route
// 							path="/manage-documents/TOS"
// 							render={ renderComp(FAQList) }
// 						/>
// 						<Route
// 							path="/manage-documents/PRIVACY"
// 							render={ renderComp(FAQList) }
// 						/>
// 					</div>
// 				</div>
// 			</Fragment>
// 		);


// 	}



// 	// isActive (filterSlug) {
// 	// 	return () => {
// 	// 		const { typeFilter = {} } = this.props.documentStore;
// 	// 		const isTypeFilterSelected = _(typeFilter).values().first() === filterSlug;

// 	// 		return isTypeFilterSelected;
// 	// 	};
// 	// }

// 	@autobind
// 	renderRemoveButton ({ _id }) {
// 		return (
// 			<button
// 				key={ _id }
// 				data-id={ _id }
// 				onClick={ this.removeItem }
// 				className="button secondary clear margin-bottom-0">
// 					<span className="fas fa-minus"></span>
// 			</button>
// 		);
// 	}

// 	@autobind
// 	renderLabel ({ label, content }) {
// 		return (
// 			<div> 
// 				<div> <b>{ label }</b></div>
				
// 				<div> <p>{ (content.length > 256 ? (content.substring(0,256) + "...") : content) }</p></div>

// 			</div>
// 		);
// 	}

// 	@autobind
// 	onChange () {
// 		console.log("CHANGE");
// 	}

// 	@autobind
// 	onBlur () {
// 		console.log("BLUR");
// 	}

// 	@autobind
// 	removeItem ({ target }) {
// 		console.log("remove info: ");
// 		console.log(target);
// 		console.log("target.parentElement: ");
// 		console.log(target.parentElement);
		
// 		const { removeItem } = this.props;
// 		const el = target.localName === 'span' ? target.parentElement : target;
		
// 		console.log("el.dataset._id: ");
// 		console.log(el.dataset._id);
// 		// removeItem(el.dataset._id);
// 	}

// 	// @autobind
// 	// removeItem (itemID) {
// 	// 	const { playlistStore } = this.props;
// 	// 	const { _id } = this.getPlaylist();
// 	// 	playlistStore.removeSongFromPlaylist(_id, itemID);
// 	// }

// }

// export default ManageDocuments;




// return (
// 	<div className="grid-x grid-padding-x">
// 		<div className="cell small-12">
// 			{/* <NavLink
// 					data-ta="artistFAQButton"
// 					isActive={ this.isActive('ARTIST_FAQ') }
// 					to={ `/manage-content/${contentType}` }
// 			>
// 				Artist FAQs
// 			</NavLink>
// 			<NavLink
// 				data-ta="fanFAQButton"
// 				isActive={ this.isActive('FAN_FAQ') }
// 				to={ `/manage-content/${contentType}` }
// 			>
// 				Fan FAQs
// 			</NavLink> */}
// 		</div>

// 		<div className="cell small-12">
// 			{/* <a>Artist FAQs</a>&nbsp;
// 			<a>Fan FAQs</a>&nbsp;
// 			<a>Terms of Service</a>&nbsp;
// 			<a>Privacy Policy</a>&nbsp; */}
// 			<Navigation />

// 		</div>

// 		<div className="cell small-12 grid-x">
// 			<div className="cell small-7">
// 				<HFMDragDropContext
// 					// dragDropList={ [{'_id': '1', 'title': 'How do you create an account', 'content': 'Lorem ipsum dolor....'},{'_id': '2','title': 'How do you ccreate an account2', 'content': 'Lorem ipsum dolor2....'}] }
// 					dragDropList={ documentStore.testDocuments }
// 					onDragEnd={ this.props.onDragEnd }
// 					ItemLabel={ this.renderLabel }
// 					ItemButton={ this.renderRemoveButton } />
// 			</div>
// 			<div className="cell small-3"></div>
// 			<div className="cell small-2">
// 				{/* <button>Add New FAQ</button> */}
// 				<DocumentModal buttonLabel="New FAQ" icon="plus" />
// 				<DocumentModal
// 					document={ documentStore.testDocuments[1] }
// 					buttonClassName="button clear secondary padding-left-0"
// 				/>
// 			</div>
// 			<div className="cell small-7">
// 				<Editor
// 					content="TERMS OF SERVICE!"
// 					onChange={ this.onChange }
// 					onBlur={ this.onBlur }
// 				> </Editor>
// 			</div>
// 			<div className="cell small-5"></div>
// 			{/* <div className="cell small-2"></div> */}
// 		</div>
// 	</div>
// );





import React, { Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import { Route, NavLink, Redirect } from 'react-router-dom';

// import Header from './header';
// import Library from './library';
// import MyHiFives from './my-hi-fives';
// import NewReleases from './new-releases';
import Navigation from './navigation';
import FAQList from './faq-list';
import QuillDoc from './quill-document';



@inject('documentStore', 'artistStore', 'userStore', 'songsStore')
@observer
export default class ManageDocuments extends React.Component {
	constructor (props) {
		super(props);

		this.fetchData();
	}

	fetchData () {
		const { documentStore, userStore, artistStore, songsStore } = this.props;

		// documentStore.fetchIfEmpty();
		// userStore.fetchIfEmpty();
		// artistStore.fetchIfEmpty();
		// songsStore.fetchIfEmpty();
	}

	state = {};

	render() {
		const { documentStore, userStore, artistStore, songsStore } = this.props;

		if (documentStore.isLoading || userStore.isLoading || artistStore.isLoading || songsStore.isLoading) {

			return null;
		}

		const { active } = this.state;

		const LinkItem = ({ activeSlug, label, to }) => (
			<NavLink
				className={ active === activeSlug ? 'active' : '' }
				onClick={ () => { this.setState({active: activeSlug}) } }
				exact to={ to }
			>
				{ label }
			</NavLink>
		);

		// const member = userStore.getLoggedInUser();

		// if (_.isEmpty(member)) {

		// 	return null;
		// }

		console.log("active")
		console.log(active)

		const renderComp = (Comp) => (
			() => ( <Comp documentStore={ documentStore } active={ active } /> )
		);

		return (
			<Fragment>
				<div className="grid-x header-grid margin-bottom-1">
					<div className="cell small-12">
						<div className="grid-x">
							<div className="cell auto">
								<nav>
									<ul className="menu horizontal artist-nav">
										<li>
											<LinkItem
												label="Artist FAQs"
												activeSlug="ARTIST_FAQ"
												to="/manage-documents/ARTIST_FAQ"
											/>
										</li>
										<li>
											<LinkItem
												label="Fan FAQs"
												activeSlug="FAN_FAQ"
												to="/manage-documents/FAN_FAQ"
											/>
										</li>
										<li>
											<LinkItem
												label="Terms of Service"
												activeSlug="TOS"
												to="/manage-documents/TOS"
											/>
										</li>
										<li>
											<LinkItem
												label="Privacy Policy"
												activeSlug="PRIVACY"
												to="/manage-documents/PRIVACY"
											/>
										</li>
										<li>
											<LinkItem
												label="About"
												activeSlug="ABOUT"
												to="/manage-documents/ABOUT"
											/>
										</li>
										<li>
											<LinkItem
												label="Press"
												activeSlug="PRESS"
												to="/manage-documents/PRESS"
											/>
										</li>
									</ul>
								</nav>
							</div>
						</div>
					</div>
				</div>

				<div className="grid-x grid-padding-x" style={{width: '82vw'}}>
				<div className="cell small-12">
						<Route exact
							path="/manage-documents"
							render={
								() => ( <Redirect to="/manage-documents/ARTIST_FAQ" /> )
							}
						/>
						<Route
							path="/manage-documents/ARTIST_FAQ"
							render={ renderComp(FAQList) }
						/>
						<Route
							path="/manage-documents/FAN_FAQ"
							render={ renderComp(FAQList) }
						/>
						<Route
							path="/manage-documents/TOS"
							render={ renderComp(QuillDoc) }
						/>
						<Route
							path="/manage-documents/PRIVACY"
							render={ renderComp(QuillDoc) }
						/>
						<Route
							path="/manage-documents/ABOUT"
							render={ renderComp(QuillDoc) }
						/>
						<Route
							path="/manage-documents/PRESS"
							render={ renderComp(QuillDoc) }
						/>
					</div>
				</div>
			</Fragment>
		);
	}
}